import { render, staticRenderFns } from "./PlacementsStartComponentCapabilityDataCard.vue?vue&type=template&id=368d2cc2&"
import script from "./PlacementsStartComponentCapabilityDataCard.vue?vue&type=script&lang=js&"
export * from "./PlacementsStartComponentCapabilityDataCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports